import qoalaStorage from '~/core/Storage';
import { parseIfJsonString } from '~/core/helper/JSONHelper';

export default {
  getTransactionHistory: state => {
    return state.transactionHistory || [];
  },
  getPolicyList: state => {
    return state.policyList || [];
  },
  getClaims: state => {
    if (!state.claims) {
      return '';
    }
    if (state.claims === 'undefined') {
      return '';
    }
    if (typeof state.claims === 'string') {
      return JSON.parse(state.claims);
    }
    return state.claims;
  },
  getSmartphonePurchaseHistory: state => {
    return qoalaStorage.getItem('smartphonePurchaseHistory')
      ? parseIfJsonString(qoalaStorage.getItem('smartphonePurchaseHistory'))
      : state.smartphonePurchaseHistory;
    // if (typeof state.smartphonePurchaseHistory === 'string') {
    //   return JSON.parse(state.smartphonePurchaseHistory);
    // }
    // return state.smartphonePurchaseHistory || {};
  },
  getSmartphoneBrand: state => {
    return qoalaStorage.getItem('smartphoneBrand')
      ? parseIfJsonString(qoalaStorage.getItem('smartphoneBrand'))
      : state.smartphoneBrand;
    // if (typeof state.smartphoneBrand === 'string') {
    //   return JSON.parse(state.smartphoneBrand);
    // }
    // return state.smartphoneBrand || [];
  },
  getSmartphoneModel: state => {
    return qoalaStorage.getItem('smartphoneModel')
      ? parseIfJsonString(qoalaStorage.getItem('smartphoneModel'))
      : state.smartphoneModel;
    // if (typeof state.smartphoneModel === 'string') {
    //   return JSON.parse(state.smartphoneModel);
    // }
    // return state.smartphoneModel || [];
  },
  getListProduct: state =>
    qoalaStorage.getItem('smartphoneProduct')
      ? parseIfJsonString(qoalaStorage.getItem('smartphoneProduct'))
      : state.listProduct || [],
  getProductDetail: state =>
    qoalaStorage.getItem('smartphoneProductDetail')
      ? parseIfJsonString(qoalaStorage.getItem('smartphoneProductDetail'))
      : state.productDetail
};
